import React from "react";
import { useTranslation } from "react-i18next";
import trustpilotLogo from "../../../../../../assets/img/brand/trustpilot.svg";
import "./TrustpilotModal.css";

const TRUSTPILOT_URL = "https://www.trustpilot.com/review/talegacyremembered.com";
const TrustpilotModal = ({ isOpen, onLeaveReview, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleLeaveReview = () => {
    window.open(TRUSTPILOT_URL, "_blank", "noopener,noreferrer");
    onLeaveReview();
  };

  return (
    <div className="trustpilot-modal-overlay" onClick={onClose}>
      <div
        className="trustpilot-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="trustpilot-modal-brand">
          <img src={trustpilotLogo} alt="Trustpilot" className="trustpilot-logo" />
        </div>

        <div className="trustpilot-modal-body">
          <div className="trustpilot-stars">
            {[1, 2, 3, 4, 5].map((i) => (
              <span key={i} className="trustpilot-star">★</span>
            ))}
          </div>
          <h3 className="trustpilot-modal-title">{t("trustpilot_modal.title")}</h3>
          <p className="trustpilot-modal-message">{t("trustpilot_modal.message")}</p>
        </div>

        <div className="trustpilot-modal-footer">
          <button className="trustpilot-review-btn" onClick={handleLeaveReview}>
            {t("trustpilot_modal.leave_review")}
          </button>
          <button className="trustpilot-later-btn" onClick={onClose}>
            {t("trustpilot_modal.maybe_later")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrustpilotModal;
